import React from 'react';
import { Search } from 'lucide-react';

export const SearchBar = ({ value, onChange }) => {
  return (
    <div className='mb-4 mt-4'>
      <div className='input-group' style={{ maxWidth: '200px' }}>
        <span
          className='input-group-text bg-white border-end-0'
          style={{
            borderTopLeftRadius: '999px',
            borderBottomLeftRadius: '999px'
          }}
        >
          <Search size={18} />
        </span>
        <input
          type='text'
          className='form-control border-start-0'
          placeholder='Search'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            borderTopRightRadius: '999px',
            borderBottomRightRadius: '999px',
            borderLeft: 'none'
          }}
        />
      </div>
    </div>
  );
};
